import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetInvitationResponseBody } from '../InvitationsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseInvitationQueryValues = {
  invitationId: string;
};

export const invitationQueryKeyFactory: IQueryKeyFactory<
  IUseInvitationQueryValues
> = (values) => values && (['invitations', values.invitationId] as const);

export const useInvitationQuery = (
  values?: IUseInvitationQueryValues,
  options?: UseQueryOptions<IApiGetInvitationResponseBody, ApiError>,
): UseQueryResult<IApiGetInvitationResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: invitationQueryKeyFactory(values),
    queryFn: values
      ? () => api.invitations.get(values.invitationId)
      : undefined,
    ...options,
  });
};
